import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-invitations-list',
  standalone: false,
  templateUrl: './invitations-list.component.html',
  styleUrl: './invitations-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationsListComponent {
  private readonly router = inject(Router);

  readonly title = input<string>();
  readonly data = input<any>();

  readonly hasInvitation = computed(() => this.data()?.length > 0);

  onAcceptInvitation(installationId: number): void {
    this.router.navigate([
      '/installation/' + installationId + '/accept/installer',
    ]);
  }
}
